<style scoped>

</style>
<template>
  <span>{{ name }}</span>
</template>
<script>
  import {mapGetters} from "vuex";

  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
    },
    computed: {
      ...mapGetters('async', ['analysis_titles_hash']),
      name() {
        if (!this.id) return '未设置';
        const title = this.analysis_titles_hash[this.id];
        const not_found = '未找到';
        return title ? title.full_name : not_found;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      test() {
        this.$util.ajax.get('api_url', {
          params: {
            //dd
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            //成功
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          // always executed
        });
      }
    }
  }
</script>
